import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { linkStep } from "../../../redux/slices/navigation";
import { Email, EmailEdit, GetQrLink } from "../../../redux/requests/email";
import { navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { validEmailList } from "../../../RegExpValidations";
import { saveEmail } from "../../../redux/slices/saveValue";
import StepCustomize from "../../../components/stepCustomize";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import InputText from "../../../components/input/inputText";
import { SelectCategory } from "../../../components";
import InputTextarea from "../../../components/input/inputTextarea";
import useTypeDecription from "../../../hooks/useTypeDecription";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

export default function EmailPage() {
  const { lang, getQrLinkSliceId, categoryChange, valueEmail, error } =
    useSelector((state) => ({
      lang: state.changeLang.language.stepTwo,
      getQrLinkSliceId: state.getQrLinkSlice.id,
      categoryChange: state.categories.categoryChange,
      valueEmail: state.saveValue.valueEmail,
      error: state.getQrLinkSlice.error,
    }));
  const { id } = useParams();
  const { adminEntryLocation } = useCurrentLocation();

  const [email, setEmail] = useState([]);
  const dispatch = useDispatch();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  let navigate = useNavigate();
  const [emailAddress, setEmailAddress] = useState("" || valueEmail[0]);
  const [qrTitle, setQrTitle] = useState("" || valueEmail[3]);
  const [empty, setEmpty] = useState(false);
  const [subject, setSubject] = useState("" || valueEmail[1]);
  const [body, setBody] = useState("" || valueEmail[2]);
  const [emailValid, setEmailValid] = useState(false);

  useEffect(() => {
    getContent("email");
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/mail/get/${id}`)
        .then(({ data }) => {
          data[0]?.emailTo && setEmailAddress(data[0].emailTo);
          data[0]?.subject && setSubject(data[0].subject);
          data[0]?.body && setBody(data[0].body);
          setQrTitle(data.qrTitle);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function step() {
    if (!!email[0] && email[0].length > 3 && getQrLinkSliceId === null && !id) {
      setEmpty(false);
      dispatch(GetQrLink(() => Email([...email, categoryChange])));
      dispatch(saveEmail([...email]));
      dispatch(preloaderToggle(true));
      dispatch(navigationStep(3));
      navigate("/qr");
    } else {
      setEmpty(true);
    }

    if (!!getQrLinkSliceId || id) {
      dispatch(
        GetQrLink(() =>
          EmailEdit([getQrLinkSliceId || id, ...email, categoryChange])
        )
      ).then(() => {
        if (!isNoEditRoute) {
          window.location.href = adminEntryLocation;
        }
      });

      dispatch(preloaderToggle(true));
      if (isNoEditRoute) {
        dispatch(saveEmail([...email]));
        dispatch(navigationStep(3));
        navigate("/qr");
      }
    }
  }

  useEffect(() => {
    if (emailAddress !== "") {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
    setEmailValid(validEmailList.test(emailAddress));
    setEmail([emailAddress, subject, body, qrTitle]);
  }, [emailAddress, subject, body, emailValid, qrTitle]);

  useEffect(() => {
    setEmailValid(validEmailList.test(valueEmail[0].trim(" ")));
  }, [valueEmail[0]]);
  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputText
            type="email"
            placeholder={lang.email[0]}
            name="emailAddress"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
            popoverText={lang.email[24]}
            maxLength={255}
            error={!!error || (!emailValid && emailAddress.length >= 5)}
            valid={emailValid && emailAddress.length >= 5}
          >
            {!!error && (
              <Form.Text className="text-danger">{error[0].message}</Form.Text>
            )}
            {empty && (
              <Form.Text className="text-danger">{lang.email[5]}</Form.Text>
            )}
            {!emailValid && emailAddress.length >= 5 && (
              <Form.Text className="text-danger">
                {lang.vcard[46]}: {lang.email[1]}
              </Form.Text>
            )}
          </InputText>

          <InputText
            type="text"
            placeholder={lang.email[2]}
            name="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            valid={subject.length}
            popoverText={lang.email[25]}
          />

          <InputTextarea
            placeholder={lang.email[4]}
            name="Body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            maxLength={5000}
            valid={body.length}
            popoverText={lang.email[26]}
          />

          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>

        <SelectCategory />
        <StepCustomize
          emulate={step}
          disabled={!emailValid || !emailAddress.length}
        />
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
}
